import { ErrorResponse } from "@/app/types/error";
import { CountryDTO } from "./types";
import { getApi } from "../config";

export const getAllCountries = async (): Promise<
  { status: string; data: CountryDTO[] } | ErrorResponse
> => {
  const response = await getApi<
    { status: string; data: CountryDTO[] } | ErrorResponse
  >("/country/all", {});

  if (response.status === "fail") return response as ErrorResponse;
  return response;
};
